<template>
  <div>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.type"
      :multi-line="true"
      :timeout="snackbar.timeout"
      :top="true"
    >
      <div>
        <span v-html="snackbar.message" />
        <div v-if="snackbar.oneButton">
          <v-btn
            dark
            flat
            @click="snackbar.onOneButtonClick"
          >
          {{ snackbar.oneButtonLabel }}
          </v-btn>
        </div>
        <div v-if="snackbar.buttons">
          <v-btn
            dark
            flat
            @click="snackbar.onClickYes"
          >
            Yes
          </v-btn>
          <v-btn
            dark
            flat
            @click="snackbar.onClickNo"
          >
            No
          </v-btn>
        </div>
      </div>
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>

import { mapState } from 'vuex'
export default {
  computed: mapState(['snackbar']),
  mounted () {
    // this.snackbar = this.show
    // this.props
  }
}
</script>
